/* 🤖 this file was generated by svg-to-ts */
export const matIconExpandMore: {
  name: 'expand-more';
  data: string;
} = {
  name: 'expand-more',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/></svg>`
};
